import React, { useState } from 'react';
import { ButtonPrimary, Spinner } from '../../StyledComponent';
import MessagePopUp from '../../MessagePopup';
import Cognito from '../../../Amplify';

const ResendCode = ({ tema, setShowResendModal, email }) => {
  const [isLoadingResendCode, setIsLoadingResendCode] = useState(false);
  const [isShowMessageSuccess, setIsShowMessageSuccess] = useState(false);
  const [codeResended, setCodeResended] = useState(false);

  async function sendNewCode() {
    setIsLoadingResendCode(true);
    await Cognito.resendCode(email);
    setIsLoadingResendCode(false);
    setCodeResended(true);
  }

  return (
    <div>
      {!isShowMessageSuccess && (
        <MessagePopUp
          noIcon
          title={'Código de verificação'}
          txtAlign={'left'}
          onClose={() => setShowResendModal(false)}
          tema={tema}
          containerButtonsDirection={'column'}
          message={
            <>
              <span style={{ color: '#B91C1C' }}>
                <span>
                  Antes de fazer o pedido de um novo código de verificação,{' '}
                </span>
                <b>
                  confira sua caixa de entrada, spam ou lixo eletrônico do
                  e-mail cadastrado.
                </b>
              </span>
              <br />
              <br />
              <span>
                Caso não receba o código de verificação novamente, favor entrar
                em contato com nosso suporte.
              </span>
            </>
          }
        >
          <ButtonPrimary
            tema={tema}
            fullWidth
            onClick={sendNewCode}
            disabled={isLoadingResendCode || codeResended}
          >
            {isLoadingResendCode && !codeResended && (
              <>
                <span>Reenviando...</span> <Spinner />
              </>
            )}

            {!isLoadingResendCode && !codeResended && (
              <span>REENVIAR CÓDIGO</span>
            )}

            {codeResended && <span>CÓDIGO REENVIADO</span>}
          </ButtonPrimary>

          <ButtonPrimary
            tema={tema}
            fullWidth
            light
            onClick={() => setShowResendModal(false)}
            disabled={isLoadingResendCode}
          >
            ENCONTREI MEU CÓDIGO
          </ButtonPrimary>
        </MessagePopUp>
      )}

      {isShowMessageSuccess && (
        <MessagePopUp
          title={'Código reenviado com sucesso'}
          tema={tema}
          message={'Enviamos um novo código para o seu e-mail.'}
        >
          <ButtonPrimary
            tema={tema}
            fullWidth
            light
            onClick={() => setIsShowMessageSuccess(false)}
          >
            FECHAR
          </ButtonPrimary>
        </MessagePopUp>
      )}
    </div>
  );
};

export default ResendCode;
